var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"rx-footer"}},[_c('div',{staticClass:"work"},[_c('i',{staticClass:"far fa-copyright"}),_vm._v(" WellAI LLC 2020 ")])])}]

export { render, staticRenderFns }